import {
  GET_OFFERID,
  ADD_OFFER,
  UPDATE_OFFER,
  GET_OFFER,
  DELETE_OFFER,
  SET_ZERO_OFFER
} from "../constants/ActionTypes";
import isEmpty from "lodash/isEmpty";
import { translate } from "../util/intlHelper";

const INIT_STATE = {
  Offers: [],
  offerid: 0,
  name: "",
  date: "",
  lastChanged: "",
  status: "",
  category: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_ZERO_OFFER:{
      return INIT_STATE;
    }
    case ADD_OFFER: {
      return {
        ...state,
        Offers: [
          ...state.Offers,
          {
            offerid: action.payload,
            name: "",
            date: "",
            lastChanged: "",
            status: "",
            category: "",
          },
        ],
        offerid: action.payload,
        success: !isEmpty(action.payload),
      };
    }
    case DELETE_OFFER: {
      return {
        ...state,
        Offers: state.Offers.filter((offer) => offer.id !== action.payload),
        success: !isEmpty(action.payload),
      };
    }
    case GET_OFFERID: {
      return {
        ...state,
        offerid: action.payload,
        success: !isEmpty(action.payload),
      };
    }
    case UPDATE_OFFER: {
      return {
        ...state,
        name: action.payload,
        category: action.playload,
        success: !isEmpty(action.payload),
      };
    }

    case GET_OFFER: {
      return {
        ...state,
        Offers: action.payload,
        success: !isEmpty(action.payload),
      };
    }

    default:
      return state;
  }
};
